import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100">热门话题</h2>
          <p className="text-sm text-foreground-500 mt-3">大家都在讨论的影视话题</p>
        </div>
        <div className="flex flex-wrap gap-3 justify-center">
          {topicsData.map((topic, i) => (
            <div
              key={i}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-xl border cursor-pointer transition-all ${
                topic.hot
                  ? 'bg-primary-500/10 border-primary-500/25 hover:bg-primary-500/20'
                  : 'bg-background-50 border-background-200/50 hover:border-foreground-300/30'
              }`}
            >
              {topic.hot && (
                <i className="ri-fire-line text-accent-500 text-sm"></i>
              )}
              <span className={`text-sm font-medium whitespace-nowrap ${
                topic.hot ? 'text-primary-400' : 'text-foreground-300'
              }`}>
                #{topic.name}
              </span>
              <span className="text-[10px] text-foreground-500 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}